import React, { useEffect, useState } from "react";
import { getErrorMessage } from "../utils/Errors";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Space from "../ui/Space";
import Card from "../ui/Card";
import Menu from "../ui/Menu";
import VirtualTable from "../ui/VirtualTable";
import { createModal } from "../hooks/createModal";
import ClassSelection from "./ClassSelection";
import Nav from "../ui/Nav";
import Input from "../ui/Input";
import { requestPrompt, sortBisacsByDescription } from "../utils/Utils";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import Status from "../ui/Status";
import { useTabs } from "../hooks/useTabs";
import { InfoIcon } from "../utils/Icons";
import Popup from "../ui/Popup";
import Label from "../ui/Label";
import Confirm from "../popups/Confirm";

export default function Bisacs(props) {

    const { controller = "", value = "", callback = () => { }, route = "", modal = false, hasBisac = false } = props;
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [sectionBisacs, setSectionBisacs] = useState([]);
    const [activePane, setActivePane] = useState("left");
    const [align, setAlign] = useState("auto");
    const [selectedTitle, setSelectedTitle] = useState({});
    const [label, setLabel] = useState({});
    const [filter, setFilter] = useState("");
    const [groupFilter, setGroupFilter] = useState("");
    const [state, setState] = useState({
        edit: false,
    })

    const min = activePane === ("center") ? true : false;


    useEffect(() => {
        const bisacs = selected?.bisacs || [];
        if (!bisacs.length) {
            setSectionBisacs([]);
            setSelectedTitle({});
            return;
        }

        const sortedBisacs = sortBisacsByDescription(bisacs).map((subject) => ({
            ...subject,
            description: subject.description || "",
        }));
        const initialTitle = sortedBisacs.find((item) => item?.bisac === value) || sortedBisacs[0] || {};

        setSectionBisacs(sortedBisacs);
        setSelectedTitle(initialTitle);

        if (initialTitle?.bisac === value) {
            setLabel(initialTitle);
        }
    }, [selected, value]);

    const fetchAuthor = () => {
        pubCall("bisac.getAll", {}, (_s, _r) => {
            if (_s) {
                if (_r.length > 0) {
                    if (value) {
                        let _f = _r.findIndex((item) => item.code === value.slice(0, 3))
                        if (_f > -1) {
                            setSelected(_r[_f])
                        } else {
                            setSelected(_r[0])
                        }
                    } else {
                        setSelected(_r[0]);
                    }
                    setData(_r);
                } else {
                    setSelected({});
                    setSelectedTitle({});
                }
            } else {
                showError({error : getErrorMessage(_r.error, "stock.searchAuthor")})
            }
        })
    }

    useEffect(fetchAuthor, [])

    const switchSides = (pane = "left") => {

        if (pane === "left") {
            setFilter("");
            window.bm_state.value = route;
        } else if (pane === "center") {
            window.bm_state.value = ROUTES.HELPERS.BISACS_RIGHT;
        } else {
            window.bm_state.value = ROUTES.HELPERS.BISAC_SELECTED;
        }

        setActivePane(pane);
    }

    const saveBisac = (edit) => {
        const category_1 = edit ? getVal("category_1") || "" : props.selected?.category_1 || "";
        const category_2 = edit ? getVal("category_2") || "" : props.selected?.category_2 || "";

        const updateSelectedBisac = () => {
            const bisac_info = {
                bisac: selectedTitle?.bisac || "",
                bisac_id: selectedTitle?.bisac_id || "",
                category_1,
                category_2,
                description: selectedTitle?.description || "",
            };

            pubCall("bisac.update", { bisac_id: selectedTitle?.bisac_id || "", bisac_info }, (_s, _r) => {
                if (!_s) {
                    showError(_r);
                    return;
                }

                showMessage("Bisac updated");
                const updatedTitle = {
                    ...selectedTitle,
                    category_1: _r.category_1 || category_1,
                    category_2: _r.category_2 || category_2,
                };
                const updatedBisacs = sortBisacsByDescription(
                    sectionBisacs.map((bisac) =>
                        bisac.bisac_id === selectedTitle?.bisac_id
                            ? updatedTitle
                            : bisac
                    )
                );

                setSectionBisacs(updatedBisacs);
                setSelectedTitle(updatedTitle);
                setState((s) => ({ ...s, edit: false }));
                setTabs(defaultTabs);
            });
        };

        if (!selectedTitle?.description?.includes("General")) {
            updateSelectedBisac();
            return;
        }

        pubCall("bisac.getChildren", { bisac_id: selectedTitle?.bisac_id || "" }, (_s, _r) => {
            if (!_s) {
                showError(_r);
                return;
            }

            if (!_r?.count) {
                updateSelectedBisac();
                return;
            }

            window.bm_state.value = ROUTES.HELPERS.CONFIRM;
            createModal({
                alert: true,
                component: (
                    <Confirm
                        controller={controller}
                        title="Multiple BISACs"
                        description={<>Do you want to link all {_r.count} BISAC records for this classification?<div className="shim" /></>}
                        route={ROUTES.HELPERS.CONFIRM}
                    />
                ),
                closable: true,
                callback: (updateChildren) => {
                    window.bm_state.value = ROUTES.HELPERS.BISACS_RIGHT;
                    if (updateChildren !== true) {
                        return;
                    }

                    const bisacIds = [...new Set([
                        ...(_r.ids || []),
                        selectedTitle?.bisac_id,
                    ].filter(Boolean))];

                    pubCall("bisac.massUpdateBisacCategory", {
                        bisac_ids: bisacIds,
                        category_1,
                        category_2,
                    }, (_s2, _r2) => {
                        if (!_s2) {
                            showError(_r2);
                            return;
                        }

                        showMessage(`Updated ${_r.count + 1} BISAC records`);
                        const updatedIds = new Set(bisacIds);
                        const updatedBisacs = sortBisacsByDescription(
                            sectionBisacs.map((bisac) =>
                                updatedIds.has(bisac.bisac_id)
                                    ? { ...bisac, category_1, category_2 }
                                    : bisac
                            )
                        );

                        setSectionBisacs(updatedBisacs);

                        if (updatedIds.has(selectedTitle?.bisac_id)) {
                            setSelectedTitle((prev) => ({ ...prev, category_1, category_2 }));
                        }

                        setState((s) => ({ ...s, edit: false }));
                        setTabs(defaultTabs);
                    });
                },
            });
        });
    };

    const setBisac = () => {
        if (window.bm_state.value !== route) {
            callback(selectedTitle.bisac);
        } else {
            switchSides(false);
        }
    }

    const showEditRow = () => {
        if (selectedTitle?.bisac) {
            setTabs([
                { label: "category_1", key: "category_1", value: selectedTitle?.category_1 || "" },
                { label: "category_2", key: "category_2", value: selectedTitle?.category_2 || "" },
            ]);
            setState(s => ({ ...s, edit: true }));
            setIndex("category_1");
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    refs.current?.category_1?.focus();
                })
            })
        }
    }

    const drawFilter = () => {
        requestPrompt({
            route: ROUTES.HELPERS.BISACS_RIGHT,
            controller: controller,
            description: "Show only sub-subjects with",
            enterOverwrite: true,
            title: "BISAC filter",
            inputProps: { style: { "textAlign": "left" } },
            callback: (searchTerm) => {
                window.bm_state.value = ROUTES.HELPERS.BISACS_RIGHT;
                setFilter(searchTerm || "");
            }
        })
    }


    const drawSearch = () => {
        requestPrompt({
            route: ROUTES.HELPERS.BISACS_RIGHT,
            controller: controller,
            enterOverwrite: true,
            title: "Search BISAC Description",
            inputProps: {
                style: { "textAlign": "left" }
            },
            callback: (searchTerm) => {
                if (!searchTerm) return;
                
                const searchLower = searchTerm.toLowerCase();
                
                const matchingBisac = sectionBisacs.find(bisac =>
                    bisac.description?.toLowerCase().includes(searchLower)
                );
                
                if (matchingBisac) {
                    setSelectedTitle(matchingBisac);
                    setAlign("start");
                } else {
                    showMessage("No matching BISAC description found");
                }
            }
        })
    }

    const filteredBisacs = sectionBisacs.filter((item) => {
        const matchesFilter = !filter || [
            item?.bisac,
            item?.description,
            item?.category_1,
            item?.category_2,
        ].join(" ").toLowerCase().includes(filter.toLowerCase());

        const matchesGroupFilter = !groupFilter || [
            item?.bisac,
            item?.description,
        ].join(" ").toLowerCase().includes(groupFilter.toLowerCase());

        return matchesFilter && matchesGroupFilter;
    });

    const filteredBisacsKey = filteredBisacs.map((item) => item?.bisac).join("|");

    useEffect(() => {
        if ((!filter && !groupFilter) || filteredBisacs.length === 0) return;

        const isCurrentVisible = filteredBisacs.some((item) => item?.bisac === selectedTitle?.bisac);
        if (!isCurrentVisible) {
            setSelectedTitle(filteredBisacs[0]);
        }
    }, [filteredBisacsKey]);

    const filteredData = data.filter((group) => {
        if (!groupFilter) return true;

        const searchTerm = groupFilter.toLowerCase();
        return (group?.bisacs || []).some((bisac) => {
            const searchFilter = [bisac?.bisac, bisac?.description].join(" ").toLowerCase();
            return searchFilter.includes(searchTerm);
        });
    });

    useEffect(() => {
        if (!groupFilter || filteredData.length === 0) return;

        const isCurrentVisible = filteredData.some((item) => item?.code === selected?.code);
        if (!isCurrentVisible) {
            setSelected(filteredData[0]);
        }
    }, [groupFilter, filteredData.length]);

    const drawGroupFilter = () => {
        requestPrompt({
            route: route,
            controller: controller,
            description: "Show only BISAC groups with sub-bisacs matching",
            enterOverwrite: true,
            title: "BISAC group filter",
            inputProps: { style: { "textAlign": "left" } },
            callback: (searchTerm) => {
                window.bm_state.value = route;
                setGroupFilter(searchTerm || "");
            }
        })
    }

    const sub_nav = [
        { key: KBD.ENTER, action: (e) => { hasBisac ? saveBisac() : setBisac()} },
        { key: KBD.ESCAPE, action: (e) => { callback() } },
        ...(window.beta ? [{ text: "Edt" }] : [{ text: "Edt", key: KBD.E, action: showEditRow }]),
        { key: KBD.F, text: "Fltr", action: () => { drawFilter() } },
        { key: KBD.S, text: "Srch", action: () => { drawSearch() } },
        { key: KBD.ARROW_LEFT, action: (e) => { switchSides("left") } },
    ]

    const nav = [
        { key: KBD.ENTER, action: (e) => { switchSides("center") } },
        { key: KBD.ESCAPE, action: (e) => { callback() } },
        { key: KBD.F, text: "Filter", action: () => { drawGroupFilter() } },
        { key: KBD.ARROW_RIGHT, text: "→ Links", action: (e) => { switchSides("center") } },
    ]

    useEffect(() => {
        const cleanup = listen(controller, route, nav, false);
        return cleanup;
    }, [selected, selectedTitle]);

    const bisac_columns = [
        { min: true, key: "code", align: "center", title: <>Code</>, width: 60 },
        { min: false, key: "description", align: "left", title: <>Description</>, width: 289 },
    ]

    const title_columns = [
        { key: "bisac", align: "left", title: <>Bisac</>, width: 110, },
        { key: "description", align: "left", title: <>Description</>, grow : true, width: 500 },
        { key: "class", align: "left", title: <>Description</>, grow : true, width: 200, render : (e, f) => {
            if (canEditRow(f)) {
                return <><Input className="fill" tabMax={() => next()} style={{ width: "95px" }} maxLength={8} {...editProps("category_1")} edit={true}/> - <Input className="fill" tabMax={() => next()} style={{ width: "95px" }} maxLength={8} {...editProps("category_2")} edit={true}/> </>
            }
            return(
                <Space>
                    <Label width={75} style={{"textAlign" : "left"}}>{f.category_1}</Label>
                    <Label width={10} style={{"textAlign" : "center"}}>-</Label>
                    <Label width={75} style={{"textAlign" : "left"}}>{f.category_2}</Label>
                </Space>
            )
        }},
    ]

    const defaultTabs = [
        { label: "category_1", key: "category_1", value: "" },
        { label: "category_2", key: "category_2", value: "" },
    ]

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs

    } = useTabs(defaultTabs, "bisac_id");

    const getColumns = () => {
        return (min) ? bisac_columns.filter(item => item.min) : bisac_columns;
    }

    useEffect(() => {
        if (!state.edit) return;
        requestAnimationFrame(() => {
            const el = refs?.current[index];
            if (el) el.focus();
        });
    }, [index]);

    const cancelEditRow = () => {
        setState(s => ({ ...s, edit: false }));
        setTabs(defaultTabs);
    }

    const openBisacSelector = () => {
        window.bm_state.value = ROUTES.HELPERS.CLASSFILE_BISACS;
        createModal({
            component: <ClassSelection search={getVal("category_1")} route={ROUTES.HELPERS.CLASSFILE_BISACS} controller={controller} />,
            closable: true,
            title: "Select Classification",
            callback: (e) => {
                window.bm_state.value = ROUTES.HELPERS.BISACS_RIGHT;
                if (e) {
                    setTabs([
                        { label: "category_1", key: "category_1", value: e.category_1 || "" },
                        { label: "category_2", key: "category_2", value: e.category_2 || "" },
                    ]);
                    setState(s => ({ ...s, edit: true }));
                    setIndex("category_1");
                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            refs.current?.category_1?.focus();
                        })
                    })
                }
            }
        })
    }

    const edit_nav = [
        { key: KBD.ESCAPE, action: () => { cancelEditRow() } },
        { key: KBD.ENTER, action: () => { next() } },
        { key: KBD.ARROW_DOWN, action: () => { next() } },
        { key: KBD.PAGE_UP, action: () => { openBisacSelector() } },
        { key: KBD.PAGE_DOWN, action: () => { saveBisac(true) } },
        { key: KBD.TAB, action: () => { next() } },
        { key: KBD.ARROW_UP, action: () => { prev() } },
    ]

    useEffect(() => {
        const actions = (state?.edit) ? edit_nav : sub_nav;
        const cleanup = listen(controller, ROUTES.HELPERS.BISACS_RIGHT, actions, false, [KBD.ESCAPE, KBD.ARROW_DOWN, KBD.PAGE_DOWN, KBD.ARROW_UP, KBD.ENTER, KBD.TAB, KBD.PAGE_UP]);
        return cleanup;
    }, [index, tabs, refs, selected, selectedTitle, state.edit]);

    const canEditRow = (row) => {
        if (window.bm_state.value !== ROUTES.HELPERS.BISACS_RIGHT) return false;

        return state?.edit && row?.bisac === selectedTitle?.bisac;
    }

    const nextBisac = (_rows = 1) => {
        if (filteredData.length === 0) { setSelected({}); return; }
        const currentIndex = filteredData.findIndex(item => item?.code === selected?.code);
        const nextIndex = Math.min(currentIndex + _rows, filteredData.length - 1);
        setSelected(filteredData[nextIndex]);
    };

    const prevBisac = (_rows = 1) => {
        if (filteredData.length === 0) { setSelected({}); return; }
        const currentIndex = filteredData.findIndex(item => item?.code === selected?.code);
        const prevIndex = Math.max(currentIndex - _rows, 0);
        setSelected(filteredData[prevIndex]);
    };

    const nextTitle = (_rows = 1) => {
        if (!filteredBisacs.length) { setSelectedTitle({}); return; }
        setAlign("auto")
        const currentIndex = filteredBisacs.findIndex(item => item?.bisac === selectedTitle?.bisac);
        const nextIndex = Math.min(currentIndex + _rows, filteredBisacs.length - 1);
        setSelectedTitle(filteredBisacs[nextIndex]);
    };

    const prevTitle = (_rows = 1) => {
        if (!filteredBisacs.length) { setSelectedTitle({}); return; }
        setAlign("auto")
        const currentIndex = filteredBisacs.findIndex(item => item?.bisac === selectedTitle?.bisac);
        const prevIndex = Math.max(currentIndex - _rows, 0);
        setSelectedTitle(filteredBisacs[prevIndex]);
    };

    const drawMessage = () => {
        if (activePane === "left") {
            return (<>Browse BISAC group ({filteredData.length} available) Press {KBD.ARROW_RIGHT.label} to select a BISAC in this group.</>)
        } else if (activePane === "center") {
            return (<>Browsing {selected?.code}.  Press {KBD.ARROW_LEFT.label} to browse BISAC groups.  Press <strong>{KBD.ENTER.label}</strong> to select.</>)
        } else {
            return "";
        }
    }

    const draw = () => {
        return (
            <div style={{ "padding": (modal) ? "0px" : "0px 5px", "paddingBottom": (modal) ? "0px" : "5px" }}>
                {hasBisac && <>
                    <div className="shim" />
                    <div>Class: {props.selected?.category_1} - {props.selected?.category_2}</div>
                    <div className="shim" />
                </>}
                <Space>
                    <div style={{ "opacity": (activePane !== "left") ? "0.7" : "1" }} onClick={() => switchSides("left")}>
                        <VirtualTable
                            controller={controller}
                            row_key={"code"}
                            style={{ "transition": "width 220ms cubic-bezier(0.2, 0.9, 0.3, 1)" }}
                            next={nextBisac}
                            prev={prevBisac}
                            route={route}
                            current={selected}
                            data={filteredData}
                            width={(min) ? 60 : 312}
                            className= {activePane === "left" ? "" : "dimmed"}
                            scrollbar={true}
                            scrollindicator={true}
                            infinite={true}
                            height={440}
                            offset={0}
                            columns={getColumns()}
                            onRowClick={(item, event, index) => { switchSides("left"); setSelected(item) }}
                        />
                    </div>

                    <div style={{ "opacity": (activePane !== "center") ? "0.7" : "1" }} onClick={() => switchSides("center")}>
                        <VirtualTable
                            header={<Space>
                                <Label width={429} style={{"textAlign" : "left"}}><b>{selected.description || ""}</b></Label>
                                <Label width={100} style={{"textAlign" : "left"}}>Linked to Class</Label>
                                </Space>}
                            controller={controller}
                            row_key={"bisac"}
                            next={nextTitle}
                            prev={prevTitle}
                            scrollbar={true}
                            style={{ "transition": "width 220ms cubic-bezier(0.2, 0.9, 0.3, 1)" }}
                            scrollindicator={true}
                            infinite={true}
                            onRowClick={(item) => { switchSides("center"); setSelectedTitle(item) }}
                            onRowDoubleClick={(item) => { callback(item.bisac); }}
                            route={ROUTES.HELPERS.BISACS_RIGHT}
                            current={selectedTitle}
                            align={align}
                            className= {activePane === "center" ? "" : "dimmed"}
                            data={filteredBisacs}
                            width={activePane === "center" ? 920: 600}
                            height={440}
                            offset={0}
                            columns={title_columns}
                        />
                    </div>
                </Space>
                <div className="shim" /><div className="shim" />
                <Status><InfoIcon />{drawMessage()}</Status>
                <div className="shim" /><div className="shim" />
                {(activePane === "left") && <Nav nav={nav} />}
                {(activePane === "center") && <Nav nav={sub_nav} />}
            </div>
        )
    }

    const drawTitle = () => {
        if (label?.bisac) {
            return (<>BISAC - {label?.bisac} - {label.description}</>)
        } else {
            return (<>BISACs</>)
        }
    }

    if(modal){
        return <><div className="shim" />{draw()}</>; 
    }

    return (<>
        <Popup
            title={drawTitle()}
            width={"auto"}
            callback={callback}
            component={draw()}
        />
    </>)
}

